import React, { useEffect, useState } from 'react'
import BaseFilterModal from '../../../../../components/hooks/BaseFilterModal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { fetchLastestLead, fetchLead, updateLead } from '../../PanelActions'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'
import colors from '../../../../../assets/colors'
import ServiceItemsTable from './ServiceItemsTable'
import ObservationsTable from './ObservationsTable'
import Icon from '@mdi/react'
import { mdiAlert, mdiPlus } from '@mdi/js'
import filterStylesComponents from '../../../../../assets/filterComponentsStyles'
import ModalCreateDescription from './ModalCreateDescription'
import ModalTransferOs from './ModalTransferOs'
import ModalCloseLead from './ModalCloseLead'
import ModalNewOrcament from './ModalNewOrcament'
import LatestLeadHeader from './Forms/LatestLeadHeader'
import Header from './Forms/Header'
import ClientInfo from './Forms/ClientInfo'

const useStyles = makeStyles({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    animation: '$fadeIn .4s ease-in-out',
  },
  box: {
    padding: '10px 0px 20px 10px',
    width: '100%',
    borderBottom: `1px dashed ${colors.graylight}`,
    color: colors.gray,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  cardSubTitles: {
    color: colors.primary,
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 'bold',
    margin: '10px 0',
  },
  header: {},
  body: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '470px',
    paddingRight: '8px',
    '&::-webkit-scrollbar': {
      width: '3px',
      height: '8px',
      backgroundColor: colors.graylight,
    },
    '&::-webkit-scrollbar-thumb': {
      background: colors.secondary,
    },
  },
  footer: {
    marginTop: 20,
  },
  latestLead: {
    display: 'flex',
    backgroundColor: colors.bgError,
    padding: '4px 20px',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.error,
    borderRadius: '12px',
  },
})

const LeadForm = props => {
  const lead = useSelector(state => state.crmPanel.editingLead)

  const history = useHistory()
  const classes = useStyles()
  const filterStyles = filterStylesComponents()
  const dispatch = useDispatch()

  const [openObservations, setOpenObservations] = useState(false)
  const [openTransferOs, setOpenTransferOs] = useState(false)
  const [openCloseLead, setOpenCloseLead] = useState(false)
  const [openNewOrcament, setOpenNewOrcament] = useState(false)
  const [openObservationTable, setOpenObservationTable] = useState(false)
  const [latestLead, setLatestLead] = useState(null)

  const handleOpenObservations = () => {
    setOpenObservations(!openObservations)
  }

  const handleOpenObservationTable = () => {
    setOpenObservationTable(!openObservationTable)
  }

  const handleOpenTransferOs = () => {
    setOpenTransferOs(!openTransferOs)
  }

  const handleOpenCloseLead = () => {
    setOpenCloseLead(!openCloseLead)
  }

  const handleOpenNewOrcament = () => {
    setOpenNewOrcament(!openNewOrcament)
  }

  const { id } = props.match.params

  const handleClose = () => {
    history.goBack()
  }

  const searchLatestLead = async () => {
    try {
      const resp = await dispatch(fetchLastestLead(id))

      if (resp?.lead) {
        setLatestLead(resp?.lead)
      }
    } catch (e) {
      //
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    try {
      const resp = await dispatch(updateLead(id, values))

      if (resp) {
        handleClose()
      }
    } catch (e) {
      //
    }
  }

  useEffect(() => {
    searchLatestLead()
    dispatch(fetchLead(id))
  }, [id])

  return (
    <BaseFilterModal
      open
      hiddenHelpButton
      handleOpen={handleClose}
      title={`OS: ${lead?.os} | ${
        lead?.trigger_type == 20 ? 'RECORRÊNCIA' : 'OS EM ABERTO'
      }`}
    >
      <ModalCreateDescription
        open={openObservations}
        handleOpen={handleOpenObservations}
        leadId={id}
      />

      <ModalTransferOs
        open={openTransferOs}
        handleOpen={handleOpenTransferOs}
        leadId={id}
      />

      <ModalCloseLead
        open={openCloseLead}
        handleOpen={handleOpenCloseLead}
        leadId={id}
      />

      <ModalNewOrcament
        open={openNewOrcament}
        handleOpen={handleOpenNewOrcament}
        leadId={id}
      />

      <Grid item xs={12} style={{ width: '900px' }}>
        <form className={classes.container} onSubmit={handleSubmit}>
          <Box className={classes.header}>
            {latestLead?.id && (
              <LatestLeadHeader classes={classes} latestLead={latestLead} />
            )}

            <Header
              filterStyles={filterStyles}
              lead={lead}
              classes={classes}
              handleOpenTransferOs={handleOpenTransferOs}
            />
          </Box>

          <Box className={classes.body}>
            <ClientInfo
              lead={lead}
              classes={classes}
              filterStyles={filterStyles}
            />

            <Box className={classes.box}>
              <Typography className={classes.cardSubTitles}>
                Itens da OS:
              </Typography>

              <ServiceItemsTable items={lead?.service_items} />
            </Box>

            <Box className={classes.box}>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Typography className={classes.cardSubTitles}>
                    Observações
                  </Typography>
                </Grid>

                <Grid item>
                  <Button
                    type="button"
                    onClick={handleOpenObservationTable}
                    className={filterStyles.btnAdd}
                    style={{ textTransform: 'none' }}
                  >
                    Ver Observações
                  </Button>
                </Grid>
              </Grid>

              {openObservationTable && (
                <>
                  <ObservationsTable items={lead?.observations} />

                  <Grid container justifyContent="flex-end">
                    <Grid item>
                      <IconButton
                        style={{
                          borderRadius: '5px',
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          padding: '4px 12px',
                          marginTop: '4px',
                        }}
                        type="button"
                        onClick={handleOpenObservations}
                      >
                        <Icon
                          path={mdiPlus}
                          size={1}
                          style={{
                            backgroundColor: colors.primary,
                            color: '#FFF',
                            borderRadius: '50%',
                            marginRight: '4px',
                          }}
                        />
                        Adicionar observação
                      </IconButton>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </Box>

          <Box className={classes.footer}>
            <Grid container>
              <Grid item xs={6}>
                <Grid container spacing={2} justifyContent="flex-start">
                  <Grid item>
                    <Button
                      className={filterStyles.btnAdd}
                      style={{
                        backgroundColor: colors.error,
                        textTransform: 'none',
                      }}
                      type="button"
                      onClick={handleOpenCloseLead}
                    >
                      Bloquear cliente
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      className={filterStyles.btnAdd}
                      style={{ textTransform: 'none' }}
                      type="button"
                      onClick={handleOpenNewOrcament}
                    >
                      Abrir novo orçamento
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container justifyContent="flex-end">
                  <Button
                    className={filterStyles.btnAdd}
                    style={{ textTransform: 'none' }}
                    type="submit"
                  >
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </form>
      </Grid>
    </BaseFilterModal>
  )
}

export default LeadForm
